import { Empty, Pagination, Spin } from "antd";
import { FC, useEffect, useState } from "react";
import { useGetClients } from "~/services/client/client.queries";
import { useClientStore } from "./clients.store";
import { DetailClient } from "./detail-client";
import { MetaData } from "~/types/common";
import { METADATA_DEFAULT } from "~/utils/constants";
import { AlertCircle } from "lucide-react";

type Props = {};

export const ListClients: FC<Props> = () => {
  const { filters, setFilters } = useClientStore();
  const [meta, setMeta] = useState<MetaData>(METADATA_DEFAULT);
  const { data: clients, isLoading } = useGetClients({
    params: filters,
  });

  // init meta from data
  useEffect(() => {
    if (clients?.meta && clients.meta.totalItems !== meta.totalItems) {
      setMeta(clients?.meta);
    }
  }, [clients?.meta]);

  return (
    <>
      {isLoading ? (
        <Spin size="large" className="p-8 flex justify-center items-center h-[53vh] w-full" />
      ) : clients?.items.length ? (
        <>
          {clients?.items.map((client) => (
            <DetailClient
              key={client.id}
              client={client}
            />
          ))}
        </>
      ) : (
        <div className="p-8 text-center">
          <Empty
            image={
              <AlertCircle size={40} className="mx-auto text-gray-300" />
            }
            description={
              <div>
                <h3 className="text-lg font-medium text-gray-700">
                  No clients found
                </h3>
              </div>
            }
          />
        </div>
      )
      }

      {meta.totalItems > 0 && (
        <div className="w-full flex items-center justify-end mt-3">
          <Pagination
            total={meta.totalItems}
            current={filters.page}
            onChange={(page) => setFilters({ page })}
          />
        </div>
      )}
    </>
  );
};
